import Axios, { AxiosError, AxiosResponse } from "axios";
import useSwr from "swr";
import {
  BillResponse,
  CustomerLookUpRequestBody,
  CustomerLookupReponse,
  CustomerLookupRequest,
  InitiatePaymentRequest,
  InitiatePaymentResponse,
  PackageResponse,
  PackageResponseData,
  ProcessPaymentRequest,
  ProcessPaymentResponse,
} from "../types/Billings";
import { GeneralOperationResult } from "../types/GeneralResponse";
import api from "../axios";

export const useDiscoBills = (slug: string) => {
  const fetcher = (url: string) =>
    api.get(url).then((res: AxiosResponse<BillResponse>) => res.data);

  const { data, error } = useSwr(`/api/UtilityBills/GetAllBillers`, fetcher);
  return {
    discoBills: data,
    isLoading: !error && !data,
    isError: error,
  };
};

export const fetchAllBillers = async (): Promise<BillResponse> => {
  const { data } = await api.get(`/api/UtilityBills/GetAllBillers`);
  return data;
};

export const fetchAllBillersPackages = async (id: string
): Promise<BillResponse> => {
  const { data } = await api.get(
    `/api/UtilityBills/GetBillersByGroup/${id}`
  );
  return data;
};

export const fetchEachBillerPackages = async (id: string
): Promise<PackageResponse> => {
  const { data } = await api.get(
    `/api/UtilityBills/GetPackagesByBiller/${id}`
  );
  return data;
};

export const customerLookUpApi = async (request: CustomerLookUpRequestBody
): Promise<CustomerLookupReponse> => {
  const { data } = await api.post(
    `/api/UtilityBills/CustomerLookup`,
    request
  );
  return data;
};

export const fetchDiscoPackage = (slug: string) => {
  const willFetchPackage = new Promise<GeneralOperationResult<PackageResponse>>(
    (resolve) => {
      api
        .get(`/api/UtilityBills/GetBillersByGroupSlug/${slug}`)
        .then((respone: AxiosResponse<PackageResponse>) => {
          resolve({ data: respone.data });
        })
        .catch((err: AxiosError) => {
          resolve({ error: err });
        });
    }
  );

  return willFetchPackage;
};

export const customerLookUp = (request: CustomerLookupRequest) => {
  const willPerformCustomerLookup = new Promise<
    GeneralOperationResult<CustomerLookupReponse>
  >((resolve) => {
    api
      .post(`/api/UtilityBills/CustomerLookup`, request)
      .then((respone: AxiosResponse<CustomerLookupReponse>) => {
        resolve({ data: respone.data });
      })
      .catch((err: AxiosError) => {
        resolve({ error: err });
      });
  });

  return willPerformCustomerLookup;
};

export const InitiatePayment = async (request: InitiatePaymentRequest
): Promise<InitiatePaymentResponse> => {
  const { data } = await api.post(
    `/api/UtilityBills/InitiatePayment`,
    request
  );
  return data;
};

export const ProcessPayment = async (request: ProcessPaymentRequest
): Promise<ProcessPaymentResponse> => {
  const { data } = await api.post(
    `/api/UtilityBills/ProcessPayment`,
    request
  );
  return data;
};
